import { render, staticRenderFns } from "./CsRemoteAccesses.vue?vue&type=template&id=783578ea&scoped=true&"
import script from "./CsRemoteAccesses.vue?vue&type=script&lang=js&"
export * from "./CsRemoteAccesses.vue?vue&type=script&lang=js&"
import style0 from "./CsRemoteAccesses.vue?vue&type=style&index=0&id=783578ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783578ea",
  null
  
)

export default component.exports